/* eslint-disable no-undef */
import { GoogleAnalytics } from 'nextjs-google-analytics'

const Analytics = () => (
  <>
    {typeof window !== 'undefined' &&
      process.env.NEXT_PUBLIC_ENVIRONMENT === 'production' && (
        <>
          <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: `
    adroll_adv_id = "${process.env.NEXT_PUBLIC_ADROLL_ADV_ID}";
    adroll_pix_id = "${process.env.NEXT_PUBLIC_ADROLL_PIX_ID}";
    adroll_version = "2.0";

    (function(w, d, e, o, a) {
        w.__adroll_loaded = true;
        w.adroll = w.adroll || [];
        w.adroll.f = [ 'setProperties', 'identify', 'track' ];
        var roundtripUrl = "https://s.adroll.com/j/" + adroll_adv_id
                + "/roundtrip.js";
        for (a = 0; a < w.adroll.f.length; a++) {
            w.adroll[w.adroll.f[a]] = w.adroll[w.adroll.f[a]] || (function(n) {
                return function() {
                    w.adroll.push([ n, arguments ])
                }
            })(w.adroll.f[a])
        }

        e = d.createElement('script');
        o = d.getElementsByTagName('script')[0];
        e.async = 1;
        e.src = roundtripUrl;
        o.parentNode.insertBefore(e, o);
    })(window, document);
    adroll.track("pageView");`
            }}
            strategy="beforeInteractive"
          />

          <GoogleAnalytics
            // eslint-disable-next-line no-undef
            gaMeasurementId={process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID}
            trackPageViews
          />
        </>
      )}
  </>
)
export default Analytics
